import { useState, createContext, useContext } from 'react';

const useFilters = () => {
  const [filters, setFilters] = useState<any>({});

  const filtersInitialize = (filterName: string) => {
    filterName && setFilters({
      ...filters,
      [filterName]: {},
    });
  };

  const filtersUpdate = (filterName: string, filters: Object) => {
    filterName && setFilters((filtersState) => ({
      ...filtersState,
      [filterName]: {
        ...filtersState[filterName],
        ...filters,
      },
    }));
  };

  const filterByChange = (filterName: string, filterBy: string, ids: string[] = []) => {
    if (!filterName || !ids.length) {
      return;
    }

    let newState = filters[filterName][filterBy].slice(0);

    ids.forEach((id) => {
      if (!filters[filterName][filterBy].includes(id)) {
        newState.push(id);
      } else {
        newState = newState.filter((id) => !ids.includes(id));
      }
    });

    setFilters({
      ...filters,
      [filterName]: {
        ...filters[filterName],
        [filterBy]: newState.sort(),
      },
    });
  };

  const filtersReset = (filterName: string) => {
    if (filterName) {
      const filtersState = { ...filters };
      delete filtersState[filterName];
      setFilters(filtersState);
    }
  };

  const getFilters = (filterBlockName: string) => (
    filters[filterBlockName] || {}
  );

  const getFiltersByFilterName = (filterBlockName: string, filterName: string) => (
    getFilters(filterBlockName)[filterName]
  );

  return {
    filters,
    filtersInitialize,
    filtersUpdate,
    filterByChange,
    filtersReset,
    getFilters,
    getFiltersByFilterName,
  };
};

type FiltersContextType = ReturnType<typeof useFilters>;

export const FiltersContext = createContext<FiltersContextType>(null);

export const useFiltersContext = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFiltersContext must be used within a FiltersContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const FiltersContextProvider = ({ children }: IProps) => (
  <FiltersContext.Provider value={ useFilters() }>
    { children }
  </FiltersContext.Provider>
);

export default FiltersContextProvider;
